import { stage } from 'root/src/aws/util/resourcePrefix'
import { awsHostedZoneId, AWS_STACK_DOMAIN } from 'root/config/stackConfig'
import { isProdEnv } from 'root/src/shared/util/envSelect'

export const apexDomain = isProdEnv ? 'daredrop.com' : AWS_STACK_DOMAIN ?? process.env.AWS_STACK_DOMAIN
export const hostedZoneId = isProdEnv ? 'Z10DS6P5G65S82' : awsHostedZoneId
export default isProdEnv ? apexDomain : `${stage.toLowerCase()}.${apexDomain}`

export const apexDomainNet = isProdEnv ? 'daredrop.net' : undefined
export const apexDomainCo = isProdEnv ? 'daredrop.co' : undefined
export const apexDomainTeam = isProdEnv ? 'daredrop.team' : undefined
export const hostedZoneIdNet = isProdEnv ? 'Z0070994UPIAKMZZ910P' : undefined
export const hostedZoneIdCo = isProdEnv ? 'Z018130832GBPBBSR9E8Q' : undefined
export const hostedZoneIdTeam = isProdEnv ? 'Z01432963IQ60AXHDO3E4' : undefined
